import { render } from "./EpochTime.vue?vue&type=template&id=708a761b"
import script from "./EpochTime.vue?vue&type=script&lang=js"
export * from "./EpochTime.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/EpochTime.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "708a761b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('708a761b', __exports__)) {
    api.reload('708a761b', __exports__)
  }
  
  module.hot.accept("./EpochTime.vue?vue&type=template&id=708a761b", () => {
    api.rerender('708a761b', render)
  })

}


export default __exports__